import { createApp, nextTick } from "vue";
import { Carousel3d, Slide } from "vue3-carousel-3d";
import { getData } from "./util/fetchhandler.js";
import "vue3-carousel-3d/dist/index.css";

const app = createApp({
  data() {
    return {
      slides: [], // Lista de productos
      chatOpen: false,
      selected: {}, // Producto actualmente visible
      defaultIndex: 0,
      loaded: false,
      selectedQuotas: [], // Lista de cuotas del producto actual
      category: "office",
      months: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre",
      },
      currentMonth: 11,
    };
  },
  components: {
    Carousel3d,
    Slide,
  },
  created() {
    this.fetchData();
  },
  mounted() {
    let _this = this;
  
    // Seleccionamos el botón de "más info"
    let btnMoreInfo = document.querySelector(".button-more-info, .button-more-info-mobile");
  
    // Creamos un observer para detectar cuándo el livechat-wrapper aparece en el DOM
    const observer = new MutationObserver(() => {
      let chatWrapper = document.getElementById("livechat-wrapper");
  
      if (chatWrapper && btnMoreInfo) {
        // Dejamos de observar una vez que el elemento existe
        observer.disconnect();
  
        // Evento al hacer click en el botón
        btnMoreInfo.addEventListener("click", () => {
          chatWrapper.click();
          if (!oct8ne.isMobile()) {
            btnMoreInfo.style.display = "none";
          }
        });
  
        // Monitoreo del estado del chat cada 800ms
        setInterval(() => {
          chatWrapper = document.getElementById("livechat-wrapper");
          if (!oct8ne.isMobile()) {
            if(chatWrapper == null) {
              _this.chatOpen = true;
              console.log("chat abierto");
              _this.resizeCaruosel3d();
            }else{
              _this.chatOpen = false;
              console.log("chat cerrado");
              _this.resizeCaruosel3d();
              btnMoreInfo.style.display = "block";
            }
          }
        }, 800);
      }
    });
  
    // Observamos todo el body por si el wrapper se agrega en cualquier parte
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  },  
  updated() {},
  computed: {
    backgroundStyle() {
      switch (this.category) {
        case "autos":
        case "office":
          return "office-bk";
        case "motos":
          return "office-2-bk";
      }
    },
  },
  methods: {
    handleSlideChange(index) {
      this.selected = this.slides[index];
      // Verificar si el producto tiene cuotas y actualizar
      this.setQuotasSlide();
    },
    setQuotasSlide() {
      // Obtener todas las cuotas del producto seleccionado
      if (this.selected.quotas && this.selected.quotas.length > 0) {
        this.selectedQuotas = this.selected.quotas;
      } else {
        this.selectedQuotas = [];
      }
    },
    setSlideByUrlPath(data) {
      let path = window.location.pathname;
      let array = path.split("/");
      this.category = array[1];
      let id = 0;

      //si es office entonces cargo autos y motos y selecciono el primero
      if (this.category == "office") {
        this.slides.push(...data.autos);
        this.slides.push(...data.motos);
        // this.selected = this.slides[0];
        // this.setQuotasSlide();
        // return;
      } else {
        //cargo los slides dependiendo de la categoria que esta en url
        switch (this.category) {
          case "autos":
            this.slides.push(...data.autos);
            break;
          case "motos":
            this.slides.push(...data.motos);
            break;
        }

        id = isNaN(parseInt(array[2])) ? 0 : parseInt(array[2]) - 1;

        //si no es un id valido vuelvo a office
        if (id >= this.slides.length) {
          location.href = "/office";
          return;
        }
      }

      this.defaultIndex = id;
      // this.selected = this.slides[id];
      // this.setQuotasSlide();
      this.handleSlideChange(id);
    },
    resizeCaruosel3d() {
      if (this.chatOpen) {
        $("#office-carousel-container").addClass("shrink");
        $("#card-info-car").addClass("shrink");
      } else {
        $("#office-carousel-container").removeClass("shrink");
        $("#card-info-car").removeClass("shrink");
      }
    },
    formatterCurrency(val) {
      return new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
      }).format(val);
    },
    async fetchData() {
      await getData("/fetchdata").then((response) => {
        if (response.status) {
          this.setSlideByUrlPath(response.data);
          this.loaded = true;
          nextTick(() => {
            let element = document.getElementsByClassName('carousel-3d-container')[0];
            if (element != null) {
              element.style.height = '100px';
              setTimeout(() => {
                element.style.height = 'auto';
              }, "2000");
            }
          })
        } else {
          alert("Ha ocurrido un error inesperado");
        }
      });
    },
  },
})
  .use(Carousel3d)
  .use(Slide)
  .mount("#app-office");
